import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;

  return (
    <section className={css.sectionReviews}>
      <div className={css.oppoSectionHeader}>
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
        </Heading>
        <span className={css.oppoReviewCount}>
          {reviews.length} {reviews.length === 1 ? 'review' : 'reviews'}
        </span>
      </div>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      {reviews.length > 0 ? (
        <Reviews reviews={reviews} />
      ) : (
        <div className={css.oppoEmptyReviews}>
          <span aria-hidden="true">*</span>
          <p>No reviews yet for this listing.</p>
        </div>
      )}
    </section>
  );
};

export default SectionReviews;
